import {
    GET_SHIPPING_RATE_LISTING,
    GET_SHIPPING_RATE_LISTING_SUCCESS,
    GET_SHIPPING_RATE_LISTING_FAIL,
    GET_SHIPPING_RATE_DETAILS,
    GET_SHIPPING_RATE_DETAILS_SUCCESS,
    GET_SHIPPING_RATE_DETAILS_FAIL,
    ADD_SHIPPING_RATE,
    ADD_SHIPPING_RATE_SUCCESS,
    ADD_SHIPPING_RATE_FAIL,
    UPDATE_SHIPPING_RATE,
    UPDATE_SHIPPING_RATE_SUCCESS,
    UPDATE_SHIPPING_RATE_FAIL,
    DELETE_SHIPPING_RATE,
    DELETE_SHIPPING_RATE_SUCCESS,
    DELETE_SHIPPING_RATE_FAIL,
    EXPORT_SHIPPING_RATE,
    EXPORT_SHIPPING_RATE_SUCCESS,
    EXPORT_SHIPPING_RATE_FAIL,
    RESET_SHIPPING_RATE_STATE,
    RESET_SHIPPING_RATE_ATTACHMENT_STATE,
} from "./actionTypes";

export const getShippingRateListing = (shippingRate) => ({
    type: GET_SHIPPING_RATE_LISTING,
    payload: shippingRate,
});

export const getShippingRateListingSuccess = shippingRate => ({
    type: GET_SHIPPING_RATE_LISTING_SUCCESS,
    payload: shippingRate,
});

export const getShippingRateListingFail = error => ({
    type: GET_SHIPPING_RATE_LISTING_FAIL,
    payload: error,
});

export const getShippingRateDetails = shippingRateId => ({
    type: GET_SHIPPING_RATE_DETAILS,
    payload: shippingRateId,
});

export const getShippingRateDetailsSuccess = shippingRate => ({
    type: GET_SHIPPING_RATE_DETAILS_SUCCESS,
    payload: shippingRate,
});

export const getShippingRateDetailsFail = error => ({
    type: GET_SHIPPING_RATE_DETAILS_FAIL,
    payload: error,
});

export const createShippingRate = shippingRate => ({
    type: ADD_SHIPPING_RATE,
    payload: shippingRate,
});

export const createShippingRateSuccess = shippingRate => ({
    type: ADD_SHIPPING_RATE_SUCCESS,
    payload: shippingRate,
});

export const createShippingRateFail = error => ({
    type: ADD_SHIPPING_RATE_FAIL,
    payload: error,
});

export const updateShippingRate = shippingRate => ({
    type: UPDATE_SHIPPING_RATE,
    payload: shippingRate,
});

export const updateShippingRateSuccess = shippingRate => ({
    type: UPDATE_SHIPPING_RATE_SUCCESS,
    payload: shippingRate,
});

export const updateShippingRateFail = error => ({
    type: UPDATE_SHIPPING_RATE_FAIL,
    payload: error,
});

export const deleteShippingRate = shippingRateId => ({
    type: DELETE_SHIPPING_RATE,
    payload: shippingRateId,
});

export const deleteShippingRateSuccess = shippingRateId => ({
    type: DELETE_SHIPPING_RATE_SUCCESS,
    payload: shippingRateId,
});

export const deleteShippingRateFail = error => ({
    type: DELETE_SHIPPING_RATE_FAIL,
    payload: error,
});

export const exportShippingRate = data => ({
    type: EXPORT_SHIPPING_RATE,
    payload: data
});

export const exportShippingRateSuccess = data => ({
    type: EXPORT_SHIPPING_RATE_SUCCESS,
    payload: data,
});

export const exportShippingRateFail = error => ({
    type: EXPORT_SHIPPING_RATE_FAIL,
    payload: error,
});

//reset
export const resetShippingRateState = () => {
    return {
        type: RESET_SHIPPING_RATE_STATE,
    }
}
//reset attachment
export const resetShippingRateAttachmentState = () => {
    return {
        type: RESET_SHIPPING_RATE_ATTACHMENT_STATE,
    }
}

